import { Directive, ElementRef, Renderer, HostListener, Inject } from '@angular/core';
import { WindowRef } from './WindowRef';
declare var WinExternal: any;
@Directive({
    selector: "[iFocus]"
 })
 export class ExternalDirective {
    winRef : any;
    constructor() {
        this.winRef = new WinExternal();
    }
    
    @HostListener("focus", ["$event"])
    public onFocusTriggered(event: any): void {
        if(!(event.target instanceof HTMLImageElement) && this.winRef.openKeyboard){
            this.winRef.openKeyboard();
        }
    }

    @HostListener("click", ["$event"])
    public onClickTriggered(event: any): void {
        if(!(event.target instanceof HTMLImageElement) && this.winRef.openKeyboard){
            this.winRef.openKeyboard();
        }
    }

    @HostListener("focusout", ["$event"])
    public onFocusOutTriggered(event: any): void {
        if(!(event.target instanceof HTMLImageElement) && this.winRef.closeKeyboard){
            this.winRef.closeKeyboard();
        }
    }

    @HostListener("dblclick", ["$event"])
    public accessServiceForm(event: any): void{
        if(event.target instanceof HTMLImageElement && this.winRef.accessServiceForm){
            this.winRef.accessServiceForm();
        }
    }
 }


// WEBPACK FOOTER //
// ./src/app/directives/external.directive.ts